import { Nullable } from "@/api/ApiClient";
import { DynamicFormFile } from "@mavichpe/dynamic-forms";

export type SuscriptionFormData = Nullable<{
    id: string | undefined;
    numero: number;
    nombre: string;
    nombre_comercial: string;
    fecha_pago: number;
    monto: number;
    activo: boolean;
    email: string;
    telefono1: string;
    telefono1_cd?: string;
    telefono2: string;
    telefono2_cd?: string;
    tipo_identificacion: string;
    identificacion: string;
    report_format: number;
    pais: string;
    province_id: string;
    canton_id: string;
    district_id: string;
    neiboard_id: string;
    direccion: string;
    datasource: string;
    invoice_info?: string;
    quote_info?: string;
    consignment_info?: string;
    consignmentmodification_info?: string;
    hold_info?: string;
    order_info?: string;
    settlement_info?: string;
    invoice_email?: string;
    qoute_email?: string;
    consignment_email?: string;
    creditnote_email?: string;
    debitnote_email?: string;
    providerorder_email?: string;
    recibe_email: string;
    settlement_email: string;
    clientstatus_email: string;
    order_email?: string;
    block_on_limit?: boolean;
    formato_impresion: string;
    prefijo_facturacion: string;
    dias_apartado: number;
    dias_notadebito?: number;
    quick_save_button?: string;
    auto_print: boolean;
    ask_confirm?: boolean;
    no_auto_cancel_contado?: boolean;
    aditional_ticket_copy?: number;
    reprint_copies?: number;
    notes_printcopies?: number;
    recibe_printcopies?: number;
    invoice_printcopies?: number;
    items_per_page?: number;
    detail_font_size?: string;
    schema_created?: boolean;
    vencimiento: string; // Puede ser Date si lo parseas
    aplicar_imp_servicio?: boolean;
    comision_producto?: boolean;
    include_full_desc?: boolean;
    imp_servicio?: number;
    persistent: boolean;
    host: string;
    db_name: string;
    prefix: string;
    suscriptionkind_id?: number;
    pricemanaged?: string;
    percent_per_item?: boolean;
    sync_dolar?: boolean;
    order_recibe_by_created?: boolean;
    reduce_stock_on_settlement?: boolean;
    einvoice_status?: boolean;
    einvoice_p12?: string | Array<DynamicFormFile>;
    einvoice_p12Asset: any,
    einvoice_password?: string;
    einvoice_atvuser?: string;
    einvoice_atvpassword?: string;
    einvoice_sandbox?: boolean;
    einvoice_sequence_suscription_id?: number;
    printer_url?: string;
    shipping_cost?: number;
    /** Producto que se factura como linea cuando el envio lo hace el suscriptor. */
    shipping_product_id?: string;
    /** Ofrecer la guia de envio al agregar el costo de envio a un documento. */
    create_shipping_guide?: boolean;
    inventario_negativo?: boolean;
    last_copy_name?: string;
    bcc_email?: string;
    use_easypos_email?: boolean;
    invoice_order?: string;
    reference_label?: string;
    show_reference?: boolean;
    show_zone_saleman_on_clients?: boolean;
    quote_approval_flow?: boolean;
    auto_fit_comments_font?: boolean;
    show_taxpercent?: boolean;
    recalculateCurrency?: boolean;
    bank_account_on_docs?: boolean;
    disabled_acl?: boolean;
    single_dayclose?: boolean;
    interest_on_due?: number;
    is_interest_on_due?: boolean;
    beta_tester?: boolean;
    auto_cancel_rejected?: boolean;
    /** Producto que se factura como linea de interes por mora. Guarda el id del producto. */
    interest_product_id?: string;
    /** --- API externa de solo lectura --- */
    /** Interruptor maestro del API externa. */
    api_enabled?: boolean;
    /** Usuario del Basic Auth, generado como `ep_<tenantId>`. */
    api_username?: string;
    /** Contrasena del Basic Auth, en claro para poder mostrarla en pantalla. */
    api_password?: string;
    api_password_updated_at?: string;
    use_alternative_icon?: boolean;
    select_logo?: boolean;
    logo?: string | Array<DynamicFormFile>;
    logoAsset: any,
    logo2?: string | Array<DynamicFormFile>;
    logo2Asset: any,
    logo3?: string | Array<DynamicFormFile>;
    logo3Asset: any,
    watermark?: string | Array<DynamicFormFile>;
    watermarkAsset: any,
}>;

export const SuscriptionRelatedAttributes = ["einvoice_p12Asset", "logoAsset", "logo2Asset", "logo3Asset", "watermarkAsset"];